import type { SnapshotId } from '@ipfabric/utils';
import { loadGraph } from 'components/Graph/commands/loadGraph';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export interface CompareSnapshotCommand {
  snapshotToCompareId: SnapshotId | null;
}

export const compareSnapshot: GraphCommandFactory<CompareSnapshotCommand> =
  (_cmdContext, dispatch) => (command) =>
    dispatch(loadGraph, {
      overlay:
        command.snapshotToCompareId !== null
          ? {
              type: 'compare',
              snapshotToCompare: command.snapshotToCompareId,
            }
          : 'none',
    });
